import React from 'react'

/**
 * 
 * @param {string} [progress] - Progress of the progress bar
 * @param {boolean} [total] -  Total number of the progress bar
 */
function ProgressBar({label, progress, total}) {

    let progressPercentage = (progress/total)*100;

    return (
        <div className="progress-bar-container">
            <div className="progress-label">
                {label}
            </div>
            <div className="total-progress-bar">
                <div className="current-progress-bar" style={{width: `${progressPercentage}%`}}>
            </div>
            </div>
        </div>
      );
}
export default ProgressBar;